<script>
import { mapState } from "vuex"

export default {
  props: { ativar: Boolean },
  data () {
    return {
      placaPosicaoNValido: [],
    }
  },
  computed: { 
    ...mapState({
      user: state => state.moduleLogin.user,
      usuario: state => state.moduleLogin.usuario,
      email: state => state.moduleEmail.email,
      placa: state => state.moduleEmail.email.placa,
    }),
  },
  watch: {
    placa () {
      var placaAux = this.placa.toUpperCase()
      this.placaPosicaoNValido = []
      var e = [...placaAux]
      var aux = ''
      aux = this.preechendoPlaca(e[0])
      !aux.match(/^[A-Z]$/) && this.placaPosicaoNValido.push(1)
      aux = this.preechendoPlaca(e[1])
      !aux.match(/^[A-Z]$/) && this.placaPosicaoNValido.push(2)
      aux = this.preechendoPlaca(e[2])
      !aux.match(/^[A-Z]$/) && this.placaPosicaoNValido.push(3)
      aux = this.preechendoPlaca(e[3])
      !aux.match(/^[\d]$/) && this.placaPosicaoNValido.push(4)
      aux = this.preechendoPlaca(e[4])
      !aux.match(/^[A-Z|\d]$/) && this.placaPosicaoNValido.push(5)
      aux = this.preechendoPlaca(e[5])
      !aux.match(/^[\d]$/) && this.placaPosicaoNValido.push(6)
      aux = this.preechendoPlaca(e[6])
      !aux.match(/^[\d]$/) && this.placaPosicaoNValido.push(7)
      this.email.placaValido = 0 == this.placaPosicaoNValido.length
      this.email.placaCompleta = 7 == this.placa.length

      if(this.email.placaValido && this.email.placaCompleta){
        this.buscarPlaca(this.placa)
      }
    },    
  },
  methods: {
    formatarPlaca (e) {
        return e.toUpperCase()
    },
    preechendoPlaca (e) {
      if (e != undefined)
        return e
      else 
        return ''
    },
    buscarPlaca(){
      this.$store.dispatch("BUSCARPLACAEMAIL", {
        codUsuario: this.usuario.codUsuario,
        cidade: this.user.cidade,
        placa: this.email.placa
      }).then((result) => {
          if (result.length > 0) {
            this.btnBuscarAlertaVsible = false
            this.email.id = result[0].id
            this.email.cor = result[0].cor
            this.email.modelo = result[0].modelo
            this.email.nome = result[0].nome
            this.email.empresa = result[0].empresa
            this.email.email = result[0].email
            this.email.telefone = result[0].telefone
            this.$swal.fire({
              title: "Buscando Placa",
              text: "Sucesso",
              icon: "info"
            })
            this.email.estado = "alterar_ativo"
          }
          else {
            this.$swal.fire({
              title: "Buscado Email",
              text: 'Não possui cadastro de email',
              icon: "warning"
            })
            this.email.estado = 'novo_ativo'
          }
        }
      )
    },
  }
}
</script>
<template>
  <div>
    <b-form-text>Placa:</b-form-text>
    <b-form-input class="shadow rounded" v-model="email.placa" :state="(email.placaValido && email.placaCompleta) || ativar" :formatter="formatarPlaca" style="letter-spacing: 5px" maxLength=7 
                  :readonly="ativar"/>
    <b-form-invalid-feedback v-if="!email.placaCompleta" v-show="!ativar"> Placa Incompleta </b-form-invalid-feedback>
    <b-form-invalid-feedback v-else> Placa Invalida na posicao: {{placaPosicaoNValido.join()}} </b-form-invalid-feedback>
  </div>
</template>

<style>

</style>